import React, { useState, useEffect } from 'react';
import { Select, Spin, Empty, Form } from 'antd';
import { useAxiosGet } from '../configs/axios';
import debounceInput from '../function/debounceInput';
import SelectArrowSvg from '../components.js/svg/SelectArrowSvg';

const RemoteSelectForm = ({
  labelForm, //Label for <Form.Item />
  nameForm, //Name for <Form.Item />
  placeholder,
  disabled,
  className,
  rtl,
  endpoint,
  mode,
  optionText,
  optionValue,
  exclude,
  onValueChange, //onChange function
  allowClear,
  valueOption, //Pass specific value for <Option value='ID'></Option>
  labelOption, // pass just label for <Option>{ label }</Option>
  filterFromServer,
  rules,
  query, //* we using query while we need some params. depend backend developer.
  dependency //* we need while we want re fetch and rebuilding UI
}) => {
  const [data, setData] = useState([]);
  const [apiData, setApiData] = useState([]);
  const [value, setValue] = useState(undefined);

  const { request, error, loading } = useAxiosGet(endpoint, {
    offset: 0,
    limit: 100
  });

  useEffect(() => {
    if (endpoint) {
      loadData();
    }
  }, dependency || []);

  const onChange = (object) => {
    setValue(object);
    try {
      const key = object ? object.value : undefined;
      const objectLabel = apiData.find((d) => d[valueOption] == key);
      onValueChange({ key, object, objectLabel });
    } catch (e) {
      //
    }
  };

  const onSearch = (searchQuery) => {
    loadData(searchQuery);
  };

  const loadData = async (searchQuery) => {
    await request({
      limit: 100,
      offset: 0,
      search: searchQuery,
      q: searchQuery,
      ...query
    })
      .then((res) => {
        let array = [];
        if (exclude) {
          const filtered = res.filter(
            (value) => value[valueOption] !== exclude
          );
          array = filtered;
        } else {
          array = res;
          if (!Array.isArray(array)) {
            array = res;
          }
        }

        const options = [];
        array.forEach((element) => {
          options.push({
            label:
              typeof optionText == 'function'
                ? optionText(element)
                : element[labelOption],
            value:
              typeof optionValue == 'function'
                ? optionValue(element)
                : element[valueOption]
          });
        });
        setData(options);
        setApiData(array);
      })
      .catch((e) => {
        setData([]);
      });
  };

  const onSearchDebounce = debounceInput((e) => onSearch(e));

  return (
    <Form.Item name={nameForm} label={labelForm} rules={rules}>
      <Select
        allowClear={allowClear}
        mode={mode || null}
        showSearch
        labelInValue
        disabled={disabled}
        value={value}
        notFoundContent={
          loading ? (
            <Spin size="small" />
          ) : (
            <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
          )
        }
        filterOption={
          !filterFromServer
            ? (input, option) => {
                return (option?.children ?? '')
                  .toLowerCase()
                  .includes(input.toLowerCase());
              }
            : false
        }
        onSearch={filterFromServer ? onSearchDebounce : undefined}
        onChange={onChange}
        style={{ width: '100%', height: '3.5rem' }}
        placeholder={placeholder || ''}
        className={className || undefined}
        suffixIcon={<SelectArrowSvg />}
      >
        {data.map((val) => (
          <Select.Option
            key={val.value}
            value={val.value}
            style={{ fontFamily: rtl ? 'kurdishFont' : undefined }}
          >
            {val.label}
          </Select.Option>
        ))}
      </Select>
    </Form.Item>
  );
};

export default RemoteSelectForm;

/**
 * 
 * <RemoteSelectForm
      labelForm="Payment"
      nameForm="payment_type_id"
      allowClear={false}
      filterFromServer={false}
      endpoint="/paymentTypes/list"
      valueOption="payment_type_id"
      labelOption="payment_type_name"
  />
 */
